export default "__VITE_ASSET__hdBQnyxQ__"